module.exports = __webpack_public_path__ + "img/dj2.ae2a93c3.jpg";